module.exports = __webpack_public_path__ + "img/invite-manual.5ef8bb51.png";